/* global fetch, Request, location */
import { register, find } from '../../../../Javascript/Sysmex/Utils'

const ContentPopup = el => {
  const componentPrefix = el.dataset.componentprefix
  const isOpened = (el.dataset.popupopened === '1')
  const contentUrl = el.dataset.popupcontenturl
  const contentElement = find(`.${componentPrefix}innerContent`, el)

  // Close popup with click on background layer
  el.addEventListener('click', e => {
    if (e.target.matches(`.${componentPrefix}layer`)) {
      el.setAttribute('data-popupopened', 0)

      // Reload page if requested
      if (el.dataset.reloadonclose === '1') {
        location.reload()
      }
    }
  })

  // Load external popup content
  if (isOpened && contentUrl) {
    el.setAttribute('data-hasloadingspinner', 1)
    fetch(new Request(contentUrl), { cache: 'no-cache', credentials: 'same-origin' }).then(response => {
      response.text().then(text => {
        contentElement.innerHTML = text
        el.setAttribute('data-hasloadingspinner', 0)
        contentElement.setAttribute('data-fadeincontent', 1)
      })
    })
  }
}

register('ContentPopup', ContentPopup)
